import React from 'react'
import './skeleton.less'

const WebSkeletonBar = (props) => {
  const { width = '100%' } = props
  const style = { width }
  return (
    <div className='skltn-item' style={style}></div>
  )
}

const WebSkeletonCircle = () => {
  return (
    <div className='skltn-item circle'></div>
  )
}

const WebSkeletonRow = (props) => {
  const { cols, ...otherRowProps } = props
  return (
    <div className='skltn-row' {...otherRowProps}>
      {cols.map((v, index) => <WebSkeletonBar key={index} width={v}/>)}
    </div>
  )
}

function ListSkeleton (props) {
  const rows = [
    <WebSkeletonRow key={'row1'} cols={['15%', '20%', '20%', '15%']}/>,
    <WebSkeletonRow key={'row2'} cols={['25%', '55%']} style={{ marginTop: '45px' }}/>,
    ...new Array(13).fill(undefined).map(($, index) => <WebSkeletonRow key={index} cols={['100%']}/>),
    <WebSkeletonRow key={'rowLast'} cols={['15%', '40%']}/>
  ]
  return rows
}

function CardSkeleton () {
  const combination = (
    <div style={{ width: '20%', display: 'flex' }}>
      <WebSkeletonCircle/>
      <div style={{ flex: 1 }}>
        <WebSkeletonRow cols={['50%']} style={{ marginTop: 0 }}/>
        <WebSkeletonRow cols={['100%']}/>
      </div>
    </div>
  )
  const rows = [
    <WebSkeletonRow key={'row1'} cols={['15%', '40%']}/>,
    <div key={'row2'} className='skltn-row'>{Array.from(Array(4)).map(($, index) => <React.Fragment key={`1-${index}`}>{combination}</React.Fragment>)}</div>,
    ...Array.from(Array(3)).map(($, index) => <WebSkeletonRow key={`2-${index}`} cols={['20%', '20%', '20%', '20%']}/>),
    ...Array.from(Array(10)).map(($, index) => <WebSkeletonRow key={`3-${index}`} cols={['100%']}/>)
  ]
  return rows
}

function MobSkeleton () {
  return (
    <div className="skltn-mob">
      {/* header */}
      <div className='skltn-header'>
        <div className='skltn-item skltn-title' style={{ width: '42vw' }}></div>
        <div className='skltn-item skltn-title' style={{ width: '15vw' }}></div>
      </div>
      {/* summary */}
      <div className='skltn-summary'>
        <div className='skltn-item' style={{ width: '24vw', marginBottom: '1vh' }}></div>
        {Array.from(Array(3)).map(() => {
          return (
            <div className='skltn-row' style={{ marginTop: '3vh' }}>
              <div className='skltn-item skltn-txt' style={{ width: '16vw' }}></div>
              <div className='skltn-item skltn-title' style={{ width: '72vw' }}></div>
            </div>
          )
        })}
      </div>
      {/* content-block */}
      <>
        {Array.from(Array(2)).map(() => {
          return (
            <>
              <div className='skltn-row' style={{ marginTop: '3vh' }}>
                <div className='skltn-item skltn-title' style={{ width: '19vw' }}></div>
              </div>
              <div className='skltn-row' style={{ marginTop: '3vh' }}>
                <div className='skltn-item' style={{ width: '16vw', height: '16vw' }}></div>
                <div>
                  <div className='skltn-item skltn-title' style={{ width: '42vw' }}></div>
                  <div className='skltn-item skltn-txt' style={{ width: '55vw', marginTop: '2vh' }}></div>
                  <div className='skltn-item skltn-txt' style={{ width: '45vw', marginTop: '2vh' }}></div>
                </div>
              </div>
              <div className='skltn-row' style={{ marginTop: '3vh', justifyContent: 'end' }}>
                <div className='skltn-item' style={{ width: '16vw', height: '3vh' }}></div>
                <div className='skltn-item' style={{ width: '16vw', height: '3vh', marginLeft: '2.5vw' }}></div>
              </div>
            </>
          )
        })}
      </>
      {/* footer-btns */}
      <div className="skltn-row skltn-footer">
        {Array.from(Array(3)).map(() => {
          return (
            <div className='skltn-item' style={{ width: '28vw', height: '5vh' }}></div>
          )
        })}
      </div>
    </div>
  )
}

export default function Skeleton (props) {
  const { terminalType, billType, loading = true, children } = props
  return (
    <>
      {loading && (
        <div className='ynf-skltn-wrap'>
          {terminalType === '3' ? <MobSkeleton/> : billType === 'VoucherList' ? <ListSkeleton/> : <CardSkeleton/>}
        </div>
      )}
      {children}
    </>
  )
}